import styled from 'styled-components';

export const PageContainer = styled.div`
    padding: 10px;
    height: calc(100vh - 60px);
    background-color: ${({ theme }) => theme.colors.background};
`;

export const OptionsCell = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
